export const environment = {
    production: false,

    hostname: 'https://socielite.globaledge-software.com/',
    baseUrl: 'https://socielite-api.globaledge-software.com/api/',
    webSocketHost: 'socielite-api.globaledge-software.com',
    translateAPIKey: '', // API KEY FOR GOOGLE TRANSLATE
};